import { UtensilsCrossed } from "lucide-react";
import { formatDateTime, formatPermanencia } from "../../lib/pedidoFormatters";

/** Mesa: abertura/fechamento/permanência. Senha do balcão também. */
export function PedidoMesaInfo({ pedido }) {
  const isMesa = pedido.modulo === "Mesas" || pedido.mesa_id;
  return (
    <>
      {isMesa && (
        <div className="bg-muted/30 rounded-lg p-2.5">
          <p className="text-xs font-semibold mb-1.5 flex items-center gap-1.5 text-muted-foreground">
            <UtensilsCrossed className="w-3.5 h-3.5" /> Mesa
          </p>
          <div className="space-y-1 text-xs">
            <Row label="Abertura:" value={formatDateTime(pedido.mesa_opened_at)} />
            <Row label="Fechamento:" value={formatDateTime(pedido.mesa_closed_at || pedido.ts_concluido)} />
            <div className="flex justify-between border-t border-muted pt-1 mt-1">
              <span className="text-muted-foreground font-medium">Permanência:</span>
              <span className="font-bold">
                {formatPermanencia(
                  pedido.mesa_opened_at || pedido.created_at,
                  pedido.mesa_closed_at || pedido.ts_concluido,
                )}
              </span>
            </div>
          </div>
        </div>
      )}
      {(pedido.modulo === "Balcao" || pedido.modulo === "Totem") && pedido.senha_balcao && (
        <div className="bg-orange-50 dark:bg-orange-950/30 border border-orange-200 dark:border-orange-800 rounded-lg p-3 text-center">
          <p className="text-xs text-muted-foreground mb-1">Senha do Balcão</p>
          <p className="text-4xl font-black text-orange-500">{pedido.senha_balcao}</p>
        </div>
      )}
    </>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between">
      <span className="text-muted-foreground">{label}</span>
      <span className="font-medium">{value}</span>
    </div>
  );
}
